import { Button } from 'components/Toolkit/Button/Button';

import { useReserveCTA } from './ReserveCTA.hook';

import type { ReserveCTAArgs as ReserveCTAProps } from './ReserveCTA.typed';

export const ReserveCTA = (props: ReserveCTAProps) => {
  const { reservationStatus } = props;

  const reserveCtaAttributes = useReserveCTA({
    reservationStatus,
  });

  return (
    <Button ofType="SECONDARY" {...reserveCtaAttributes}>
      Reserve
    </Button>
  );
};
